import { render, staticRenderFns } from "./CampaignMetricsList.vue?vue&type=template&id=83c52d68&scoped=true&"
import script from "./CampaignMetricsList.vue?vue&type=script&lang=js&"
export * from "./CampaignMetricsList.vue?vue&type=script&lang=js&"
import style0 from "./CampaignMetricsList.vue?vue&type=style&index=0&id=83c52d68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83c52d68",
  null
  
)

export default component.exports